// extracted by mini-css-extract-plugin
export default {"container":"styles_container__acomH","linkWrapper":"styles_linkWrapper__kPnoj","outbound":"styles_outbound__TJNet","link":"styles_link__eOoXr"};